import claims from "../features/Claims/ClaimsSlice";
import GlobalSpinner from "../components/VibrantSolComponents/GlobalSpinnerSlice";
import login from "../features/Login/LoginSlice";
import RoleManagement from "../features/RoleManagement/RoleManagementSlice";
const rootReducer = { claims, login, GlobalSpinner, RoleManagement };
export default rootReducer;
